import axios from "axios";
import { getToken } from "./auth";

const API_URL = process.env.REACT_APP_API_BASE_URL;

// Axios instance with base URL
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Automatically attach JWT token
axiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear auth data
      const Cookies = require("js-cookie").default;
      Cookies.remove("auth_token");
      Cookies.remove("user");
      // Redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

/**
 * Get all users
 */
export const getAllUsers = async () => {
  try {
    const res = await axiosInstance.get("/User/GetAllUsers");
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    throw err;
  }
};

/**
 * Get user by ID
 * @param {string} id
 */
export const getUserById = async (id) => {
  try {
    const res = await axiosInstance.get(`/User/GetUserById?id=${id}`);
    return res.data;
  } catch (err) {
    console.error(`Error fetching user ${id}:`, err);
    throw err;
  }
};

/**
 * Get user role by ID
 * @param {number} id
 */
export const getUserRoleById = async (id) => {
  try {
    const res = await axiosInstance.get(`/User/GetUserRoleById?id=${id}`);
    return res.data;
  } catch (err) {
    console.error(`Error fetching user role ${id}:`, err);
    throw err;
  }
};

/**
 * Get all user roles
 */
export const getUserRoles = async () => {
  try {
    const res = await axiosInstance.get("/User/GetUserRoles");
    return res.data;
  } catch (err) {
    console.error("Error fetching user roles:", err);
    throw err;
  }
};
